import { configureStore } from '@reduxjs/toolkit'
import restaurantFeature from "../features/restaurant/restaurantFeature"

export default configureStore({
  reducer: {
    restaurant: restaurantFeature,
  },
})
